/**
 * @flow
 * @relayHash 038e0599c442d8fc4f400482ecd6989d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteOrganizationRoleInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type DeleteRoleMutationVariables = {|
  input: DeleteOrganizationRoleInput
|};
export type DeleteRoleMutationResponse = {|
  +deleteOrganizationRole: ?{|
    +isDeleted: ?boolean
  |}
|};
export type DeleteRoleMutation = {|
  variables: DeleteRoleMutationVariables,
  response: DeleteRoleMutationResponse,
|};
*/


/*
mutation DeleteRoleMutation(
  $input: DeleteOrganizationRoleInput!
) {
  deleteOrganizationRole(input: $input) {
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteOrganizationRoleInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteOrganizationRole",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteOrganizationRolePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteRoleMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteRoleMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteRoleMutation",
    "id": null,
    "text": "mutation DeleteRoleMutation(\n  $input: DeleteOrganizationRoleInput!\n) {\n  deleteOrganizationRole(input: $input) {\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4d5c7d841d9cad0c3be78fe6801b0e89';
module.exports = node;
